import { PresentationService } from '@/services/presentation.service';
import { ServicesBuilder } from '@/utils/setup';
import { DataWorker } from '@/workers/data.worker';
import { Auth } from '@/capacitors/services/AuthService';
import { isPlatform } from '@ionic/vue';
import secureStorage from '@xpos/utils/src/secure.storage.utils';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { stopKeepAlive } from '@/utils/keep.alive';

// Drop local database and clear merchant-scoped storage (shared by unregister and outlet switch)
export const clearMerchantData = async () => {
  stopKeepAlive(); // Device leaves the outlet: stop the Android foreground service (#1757)
  const service = PresentationService.getInstance();
  await service.disable();

  const serviceFactory = await ServicesBuilder.getInstance();
  if (serviceFactory) {
    await serviceFactory.dropDatabase();
    secureStorage.removeItem('api_key');
    secureStorage.removeItem('device_uid');
    secureStorage.removeItem('merchant_uid');
    secureStorage.removeItem('vault');
    localStorage.removeItem('is_sync_completed');
    localStorage.removeItem('default_locale');
    DataWorker.getInstance().closeConnection();
  }
};

export const handleUnRegisterDevice = async () => {
  try {
    await clearMerchantData();
    await SecureStoragePlugin.remove({ key: 'token_response' }).catch(() => {});
  } catch (e) {
    console.error('Error during unregister device:', e);
  }

  if (isPlatform('capacitor')) {
    await Auth.Instance.signIn();
  } else {
    location.href = './index.html';
  }
};
